<button
  class="button button-{{ type }}"
  [class.button-spinning]="showSpinner"
  [disabled]="disabled"
  [attr.tab-index]="disabled ? '-1' : 'inherit'"
  [attr.aria-disabled]="disabled ? 'true' : undefined"
  (click)="clicked.emit()"
>
  <ng-content select="[bom-icon-before]"></ng-content>
  <span [innerHtml]="textKey ? (textKey | tekstresource) : text"></span>
  <ng-content select="[bom-icon-after]"></ng-content>
  <ng-container *ngIf="showSpinner">
    <bom-spinner size="small"></bom-spinner>
  </ng-container>
</button>
